export default __webpack_public_path__ + "static/media/avatarPlus.14db10d8.svg";